import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

import {
  CellStyleModule,
  ModuleRegistry,
  TooltipModule,
} from "ag-grid-community";

// Suppress console logs in production builds only
// if (import.meta.env.MODE === 'production') {
//   console.log = () => {};
//   console.debug = () => {};
//   console.info = () => {};
//   console.warn = () => {};
//   console.error = () => {};
// }

ModuleRegistry.registerModules([CellStyleModule, TooltipModule]);

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  //   <App />
  // </StrictMode>
  <App/>
);
